import { render, staticRenderFns } from "./SuppressedEmailPage.vue?vue&type=template&id=55f4be20"
import script from "./SuppressedEmailPage.vue?vue&type=script&lang=js"
export * from "./SuppressedEmailPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports